module.exports = __webpack_public_path__ + "static/ab-2eb1c5d1772f197b97a740b42f57815c.png";